import { BatchDeterminationContext } from '../../../contexts/BatchDeterminationContext';
import { DateRange, ProcessStatus } from '../../../interfaces/ImportHistory';
import { FILTERS } from '../../../shared/constants/ImportHistoryConstants';
import { EMPTY_STRING, INITIAL_PAGE_STATE } from '../../../shared/constants/constants';
import { getStatusStringFromCode } from '../../../shared/helpers/importHistoryHelper';
import FiltersDrawer from '../filterDrawer/FilterDrawer';
import {
	SovosMenuItem,
	SovosMonthRangePicker,
	SovosToolbar,
	SovosToolbarActions,
	SovosToolbarDropdown,
	SovosToolbarFilter,
	SovosToolbarGroup,
	SovosToolbarSearch,
	SovosToolbarTitle,
} from 'mosaic-react';
import { useContext, useMemo, useState } from 'react';

const Toolbar = () => {
	const [isOpenFilters, setIsOpenFilters] = useState<boolean>(false);
	const { filters, handleFiltersChange, processStatuses } = useContext(BatchDeterminationContext);

	const appliedFiltersCount =
		filters.startDate.filter(date => date !== '').length +
		filters.profiles.filter(value => value !== '').length +
		filters.status.filter(value => value !== '').length;

	const filtersHasOnlyOneStatus = filters.status.length === 1;
	const theFirstStatusInFilters = filters.status[0];
	const quickStatusFilter = useMemo(
		() => (filtersHasOnlyOneStatus ? theFirstStatusInFilters : ''),
		[filtersHasOnlyOneStatus, theFirstStatusInFilters]
	);

	const handleMonthRangeChange = (date: DateRange): void => {
		if (!(date.start === null && date.end === null)) {
			handleFiltersChange(FILTERS.DATE_RANGE, date);
			handleFiltersChange(FILTERS.PAGE_STATE, { ...filters.pageState, page: INITIAL_PAGE_STATE.page });
		}
	};

	const handleSearchChange = (text: string): void => {
		handleFiltersChange(FILTERS.SEARCH, text);
		handleFiltersChange(FILTERS.PAGE_STATE, { ...filters.pageState, page: INITIAL_PAGE_STATE.page });
	};

	const handleStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		handleFiltersChange(FILTERS.STATUS, [event.target.value.toString()]);
		handleFiltersChange(FILTERS.PAGE_STATE, { ...filters.pageState, page: INITIAL_PAGE_STATE.page });
	};

	return (
		<>
			<SovosToolbar>
				<SovosToolbarTitle>
					<SovosToolbarGroup>
						<SovosMonthRangePicker
							onChange={handleMonthRangeChange}
							start={filters.dateRange.start}
							end={filters.dateRange.end}
						/>
					</SovosToolbarGroup>
				</SovosToolbarTitle>
				<SovosToolbarDropdown
					value={quickStatusFilter}
					onChange={handleStatusChange}
					displayEmpty
					renderValue={(value: string) =>
						value === EMPTY_STRING ? 'Status' : getStatusStringFromCode(processStatuses, value)
					}
				>
					<SovosMenuItem value={EMPTY_STRING}>&nbsp;</SovosMenuItem>
					{processStatuses &&
						processStatuses.map((status: ProcessStatus) => (
							<SovosMenuItem key={status.id} value={status.id}>
								{status.status}
							</SovosMenuItem>
						))}
				</SovosToolbarDropdown>
				<SovosToolbarActions>
					<SovosToolbarSearch onSearch={handleSearchChange} />
					<SovosToolbarFilter onClick={() => setIsOpenFilters(true)} appliedFiltersCount={appliedFiltersCount} />
				</SovosToolbarActions>
			</SovosToolbar>
			<FiltersDrawer isOpenFilters={isOpenFilters} onClose={() => setIsOpenFilters(false)} />
		</>
	);
};

export default Toolbar;
